import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import ViewFeedbackPage from './viewFeedbackPage';

export const mapStateToProps = (state: AppState) => {
    
    return {
        attachments: state.completeOrder.viewFeedback.attachments,
        params: state.completeOrder.viewFeedback.params,
        rca: state.completeOrder.viewFeedback.rca,
        actionplan: state.completeOrder.viewFeedback.actionplan,
        reviewstatus: state.completeOrder.viewFeedback.reviewstatus,
        totalRating: state.completeOrder.viewFeedback.status,
        comments: state.completeOrder.viewFeedback.comments,
        fbtype: state.completeOrder.viewFeedback.feedbacktype,
        orderno: state.completeOrder.viewCompleteOrder[0].orderno,
        orderdate: state.completeOrder.viewCompleteOrder[0].orderdate,
        completedon: state.completeOrder.viewCompleteOrder[0].completedon,
        tat: state.completeOrder.viewCompleteOrder[0].tat,
        fname: state.completeOrder.viewCompleteOrder[0].fname,
        tool_preferred: state.completeOrder.viewCompleteOrder[0].tool_preferred,
        destination: state.completeOrder.viewCompleteOrder[0].destination,
        modelonly: state.completeOrder.viewCompleteOrder[0].modelonly,
        approval_reqd: state.completeOrder.viewCompleteOrder[0].approval_reqd,
        bravopremium: state.completeOrder.viewCompleteOrder[0].bravopremium,
        nounits: state.completeOrder.viewCompleteOrder[0].nounits
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // Commented out reset action
        },
        onComponentWillMount: () => {
            // Dispatches authentication check
            dispatch(doCheckAuthentication);
        }
    };
};

const ViewFeedbackPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ViewFeedbackPage);

export default ViewFeedbackPageContainer;



// WEBPACK FOOTER //
// ./src/components/feedback/ViewFeedbackPageContainer.tsx